import template from 'modal/user/ugc-photo-upload/photo-upload.j2';

import { bindOnPopStateEvent } from '../../../core/js/utils/browserUtils';
import { generate } from '../../../core/js/utils/componentUtils';
import { closeModal } from '../../../core/js/utils/modalUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import { removeHash } from '../../../core/js/utils/routerUtils';
import { ugcPhotoUploadSrc } from '../../../core/js/utils/ugcPhotoUploadUtils';

function attachEvents() {
    const windowEventListener = window.addEventListener ? 'addEventListener' : 'attachEvent';
    const eventResponder = window[windowEventListener];
    const message = windowEventListener === 'attachEvent' ? 'onmessage' : 'message';

    // iframe event catcher
    eventResponder(message, function(e) {
        if (e.data && typeof e.data === 'string' && e.data.indexOf('close-photo-picker') !== -1) {
            closeModal(this, e);
        }
    }, false);

    // Close modal on back-button
    bindOnPopStateEvent(this, function(e) {
        closeModal(this, e);
    });
}

function firstRender(store) {
    this.render(store, this, { ugcIframeSrc: ugcPhotoUploadSrc(store) });
}

export function onStateChange(store) {
    this.render(store, this);
}

/**
 * Bootstrap the component onto the page
 * @param {object} store The current state
 * @returns {undefined}
 */
export function initialize(store) {
    attachEvents(store);
}

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        firstRender: firstRender,
        template: template,
        name: 'modal.ugcUpload',
        replace: 'once',
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        loader: {},
        onStateChange: onStateChange,
        afterCloseAction: afterCloseAction
    };

    return generate(config, store, overrides);
}

function afterCloseAction(store) {
    // Remove hash and push state on close
    removeHash();
}
